// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rcYV","footer":"styles_footer__O3YUi"};